export default class FormValidationStrategy {
  validate(valueString, isRequired) {
    throw new Error("validate() method must be realized!");
  }

  loadErrorMessage(key, value) {
    const errorMessages = {
      empty: 'Поле "{{value}}" обязательно для заполнения',
      regexp: "Введите {{value}} в правильном формате",
      minLength: "Минимум {{value}} символа",
    };

    let message = errorMessages[key] || "";

    if (message) {
      message = message.toString().replace("{{value}}", value);
    }

    return message;
  }
}
